import { useEffect, useState } from "react";
import { MdOutlineShoppingCart } from "react-icons/md";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../../redux/actions/prodcutAction";
import { fetchWishlistData } from "../../../redux/actions/wishlistData";
import { addToWishlist, removeFromWishlist } from "../../../service/addToWishlist";
import { toast } from "react-toastify";
import { addToCart } from "../../../service/addToCart";

function formatNumber(value) {
  const num = Number(value);
  return num % 1 === 0 ? num : num.toFixed(2);
}

export default function SectionThree() {
  const navigate = useNavigate();
  const storedUser = localStorage.getItem("customeruser");
  const [itemsPerSlide, setItemsPerSlide] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);

  const { product } = useSelector(
    (state) => state.productState
  );

  const dispatch=useDispatch();

  const {wishlistData=[], wishlisterror,}=useSelector((state)=>state.wishlistState);

  useEffect(()=>{
        dispatch(fetchWishlistData());
    },[dispatch]);

  const isInWishlist = (productId) => {
    return wishlistData.some(item => item.product.id === productId);
  };

  const toggleWishlist = (productId) => {
      const storedUser = localStorage.getItem("customeruser");
      if (!storedUser) {
        toast.warning("Please login to manage your wishlist");
        setTimeout(() => navigate("/login"), 1000);
        return;
      }
      if (isInWishlist(productId)) {
        dispatch(removeFromWishlist(productId));
      } else {
  
        dispatch(addToWishlist(productId));
      }
  };

  const toggleCart=(productId)=>{
      if (!storedUser) {
        toast.warning("Please login to manage your cart");
        setTimeout(() => navigate("/login"), 1000);
        return;
      }
      dispatch(addToCart(productId));
  };

  useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      if(product.length===0){
         dispatch(fetchProducts()); 
      }      
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [dispatch,product.length]);

  const updateItemsPerSlide = () => {
    if (window.innerWidth >= 1280) {
      setItemsPerSlide(8); 
      console.log("Item per slide",itemsPerSlide);
    } else if (window.innerWidth >= 768) {
      setItemsPerSlide(4);
    } else {
      setItemsPerSlide(1); 
    }
  };

  useEffect(() => {
    updateItemsPerSlide();
    window.addEventListener("resize", updateItemsPerSlide);
    return () => window.removeEventListener("resize", updateItemsPerSlide);
  }, []);

  const totalPages = Math.ceil(product.length / itemsPerSlide);

  useEffect(() => {
    if (itemsPerSlide < product.length) {
      const interval = setInterval(() => {
        setCurrentPage((prev) => (prev + 1) % totalPages);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [itemsPerSlide,  product.length, totalPages]);

  const startIndex = currentPage * itemsPerSlide;
  const visibleProducts =
    itemsPerSlide >= product.length
      ? product
      : product
          .slice(startIndex, startIndex + itemsPerSlide)
          .concat(
            startIndex + itemsPerSlide > product.length
              ? product.slice(0, (startIndex + itemsPerSlide) % product.length)
              : []
          );

  const activeDot = currentPage;

  if (loading) {
    return <p className="text-center mt-10">Loading products...</p>;
  }

  if(wishlisterror)
  {
    if(storedUser)
    return(
      <p className="text-red-600">Wishlisr error : {wishlisterror}</p>
    );
  }

  return (
    <div className="w-full max-w-7xl mx-auto p-4">
      <div className="flex justify-center">
        <p className="text-xl md:text-2xl xl:text-3xl font-semibold mb-5">
          Our Products
        </p>
      </div>

     
      <div
        className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 transition-all duration-500
        ${visibleProducts.length <= 4 ? "grid-rows-1" : "grid-rows-2 md:grid-rows-2 xl:grid-rows-2"}`}
      >
        {visibleProducts.map((product, index) => (
          <div
            key={index}
            className="rounded-lg shadow bg-gray-100 flex flex-col justify-between pt-2 gap-5"
          >
            <div className="relative">
              <Link to={`/productdetail/${product.id}`}>
                <img src={product.images?.[0].image} alt={product.productName} className="w-full h-48 object-contain pt-5"/>

                <div className="absolute top-2 left-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                  {formatNumber(product.discountPercent)}% OFF
                </div>
              </Link>
              <div
                onClick={() => toggleWishlist(product.id)}
                className="absolute top-2 right-2 bg-white p-2 rounded-full shadow cursor-pointer"
              >
                {isInWishlist(product.id) ? (
                  <AiFillHeart className="text-xl text-red-600" />
                ) : (
                  <AiOutlineHeart className="text-xl text-red-600" />
                )}
              </div>
            </div>

            <div className="flex flex-row rounded-lg justify-between items-center bg-gradient-to-b from-[#E96364] to-[#FEB5B6] p-2">
              <Link to={`/productdetail/${product.id}`}>
                <div className="flex flex-col text-white">
                  <h2 className="flex flex-row items-center gap-1 text-sm md:text-base xl:text-lg font-semibold whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px] md:max-w-[250px] xl:max-w-[220px]">
                      {product.productName} {product.category?.name} {product.model}
                  </h2>
                  <div className="flex flex-row space-x-5 text-sm md:text-base">
                    <p>₹{formatNumber(product.discountedPrice)}</p>

                    <p className="line-through text-gray-200">
                      ₹{formatNumber(product.originalPrice)}
                    </p>
                  </div>
                </div>
              </Link>
              <button
                className={`bg-white p-2 rounded-full
                  ${product.totalStock < 1 ? "cursor-not-allowed bg-opacity-80" : "cursor-pointer"}`}
                disabled={product.totalStock < 1}
                onClick={() => toggleCart(product.id)}
              >
                <MdOutlineShoppingCart className="text-xl text-red-700" />
              </button>
            </div>
          </div>
        ))}
      </div>


    {itemsPerSlide < product.length && (
    <div className="flex justify-center mt-4 xl:mt-6 space-x-2">
    {(() => {
      const isMobile = window.innerWidth < 768;

      const dotsToRender = [];

      if (isMobile) {
        const start = Math.max(0, activeDot - 1);
        const end = Math.min(totalPages - 1, activeDot + 1);

        for (let i = start; i <= end; i++) {
          dotsToRender.push(
            <span
              key={i}
              className={`h-2 w-2 rounded-full transition-all duration-300 ${
                i === activeDot ? "bg-blue-600 scale-110" : "bg-gray-300"
              }`}
            ></span>
          );
        }

          return dotsToRender;
        } else {
          return Array.from({ length: totalPages }).map((_, i) => (
          <span
            key={i}
            className={`h-2 w-2 rounded-full transition-all duration-300 ${
              i === activeDot ? "bg-blue-600 scale-110" : "bg-gray-300"
            }`}
          ></span>
          ));
        }
        })()}
        </div>
    )}
     
      <div className="flex justify-end mt-4">
        <button
          className="text-center px-3 py-1 text-xs md:text-sm xl:text-base text-[#A63F40] bg-[#f5e0e1] border border-[#913839] rounded-lg"
          onClick={() => navigate("/productpage")}
        >
          View More
        </button>
      </div>
    </div>
  );
}
